import { render, staticRenderFns } from "./report-modal.vue?vue&type=template&id=31d9b2cf"
import script from "./report-modal.vue?vue&type=script&lang=ts"
export * from "./report-modal.vue?vue&type=script&lang=ts"
import style0 from "./report-modal.vue?vue&type=style&index=0&id=31d9b2cf&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d9b2cf')) {
      api.createRecord('31d9b2cf', component.options)
    } else {
      api.reload('31d9b2cf', component.options)
    }
    module.hot.accept("./report-modal.vue?vue&type=template&id=31d9b2cf", function () {
      api.rerender('31d9b2cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/report-modal/report-modal.vue"
export default component.exports